import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import logger from "@insite/client-framework/Logger";
import { CentroConnectSearchResult, searchCentroConnect } from "@tCentro/Services/CENCentroConnectService";

type HandlerType = ApiHandler<
    { query: string; onSuccess?: (data: CentroConnectSearchResult) => void; onError?: () => void },
    CentroConnectSearchResult
>;

export const BeginSearch: HandlerType = props => {
    props.dispatch({
        type: "Custom/CentroConnect/BeginSearch",
        query: props.parameter.query,
    });
};

export const RequestSearchFromApi: HandlerType = async props => {
    try {
        props.apiResult = await searchCentroConnect(props.parameter.query);
    } catch (error) {
        logger.error("Error fetching Centro Connect search results:", error);
        props.dispatch({
            type: "Custom/CentroConnect/FailedSearch",
        });
        props.parameter.onError?.();
    }
};

export const DispatchCompleteSearch: HandlerType = props => {
    if (!props.apiResult) {
        return;
    }
    props.dispatch({
        type: "Custom/CentroConnect/CompleteSearch",
        searchResults: props.apiResult,
    });
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.(props.apiResult!);
};

export const chain = [BeginSearch, RequestSearchFromApi, DispatchCompleteSearch, ExecuteOnSuccessCallback];

const searchCentroConnectHandler = createHandlerChainRunner(chain, "SearchCentroConnectHandler");
export default searchCentroConnectHandler;
